import { z } from 'zod';
import { defineStepType } from '../contract.js';
/**
 * Read-and-acknowledge with no artifact — "here is where to park", "bring photo ID".
 * The simplest possible type, and the proof that a step type needs nothing but a pair
 * of schemas and an effects function.
 */
export const infoTask = defineStepType({
    type: 'info-task',
    /** The person reads it and confirms; nothing else closes it. */
    submittedBy: 'person',
    label: 'Information',
    description: 'Something the person needs to read. Produces no document and never expires.',
    configSchema: z.object({
        heading: z.string().min(1),
        bodyText: z.string().min(1),
        requiresConfirmation: z.boolean().default(true),
    }),
    submissionSchema: z.object({
        readAt: z.string().datetime(),
    }),
    onApprove: ({ instance }) => [{ kind: 'recompute-rollup', personId: instance.personId }],
});
//# sourceMappingURL=info-task.js.map